import { Stack, Table, TableActiveColumnFilters, TableHeader, TableProvider } from '@optimus-web/core';
import { useReservationsTableStateContext } from '../../../../ReservationsTableStateContext';
import { ReportTitle, useResourcesCategoriesQuery } from '../../../common';
import { ReservationsFilterValues } from '../filters';
import { UseColumnsParams, useColumns, useColumnsVisibility, useGuestInHouseQuery } from './hooks';
import { useServiceAgeCategories } from './components';

export interface ReservationsTableProps extends Omit<UseColumnsParams, 'accounts' | 'serviceId'> {
    filterValues: ReservationsFilterValues;
}

const emptyTableProps = {
    data: [],
    amountOfRows: 0,
};

export const ReservationsTable = ({ filterValues, ...handlers }: ReservationsTableProps) => {
    const { startDate, endDate, serviceId, visibleColumns } = filterValues;
    const { isFetching: isResourcesCategoriesPrefetching } = useResourcesCategoriesQuery();
    const { isFetching: isAgeCategoriesPrefetching } = useServiceAgeCategories({ serviceId });
    const { reservationsTableState: tableState, setReservationsTableState: setTableState } =
        useReservationsTableStateContext();

    const { data, isFetching } = useGuestInHouseQuery({
        enabled: true,
        filterValues,
        tableState,
    });

    const columns = useColumns({
        ...handlers,
        accounts: data?.accounts,
        balanceAndPreauthorizations: data?.balanceAndPreauthorizations,
        loyaltyMemberships: data?.loyaltyMemberships,
        verificationPhotos: data?.verificationPhotos,
        serviceId,
    });
    const columnVisibility = useColumnsVisibility({ visibleColumns });

    const tableProps = data
        ? {
              amountOfRows: data.totalRowCount,
              data: data.guestInHouseReportData,
          }
        : emptyTableProps;

    return (
        <TableProvider columns={columns} state={tableState} onStateChange={setTableState}>
            <TableHeader title={<ReportTitle startDate={startDate} endDate={endDate} />} />
            <TableActiveColumnFilters />
            <Stack vertical>
                <Table
                    uniqueRowId="reservationId"
                    {...tableProps}
                    manualFiltering
                    manualSorting
                    loading={isFetching || isResourcesCategoriesPrefetching || isAgeCategoriesPrefetching}
                    columnVisibility={columnVisibility}
                />
            </Stack>
        </TableProvider>
    );
};
